import { muiStyles } from 'utils/design';

export const useStyles = muiStyles({
  instructionBtn: {
    padding: '9px 18px',
  },
});
